export default "__VITE_ASSET__eac70c50__"